<template>
    <div>
       <el-row class="infoLink">
            <router-link to="/my/security/verification">{{$t('safetyPage.tip29')}}</router-link>
            <router-link to="/my/security/capital">{{$t('safetyPage.tip30')}}</router-link>
            <router-link to="/my/security/login">{{$t('safetyPage.tip31')}}</router-link>
            <router-link to="/my/security/device">{{$t('safetyPage.tip32')}}</router-link>
        </el-row>
       <router-view></router-view>
    </div>
</template>
<script>
export default {
    
}
</script>